import React, { useState, useEffect } from 'react';
import Header from './gapsy-header';
import Navigation from './gapsy-Mnavigation';
import Footer from './gapsy-footer';
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap-icons/font/bootstrap-icons.css';
import styles from '../assets/css/gapsy-dashboard.module.css';
import axios from 'axios';
import { Modal } from 'react-bootstrap';
import { FormStructureComponent } from "../components/TableProperty";
import { useNavigate } from 'react-router-dom';
import { makermodifypastdata, FormTextFile, PortURL } from "../components/ApiProperty";
import { LoadingIcon } from "../components/Propertyfile";

const GapsyModifyPastData = () => {
    const [formData, setFormData] = useState({});
    const [error, setError] = useState('');
    const [formStructure, setFormStructure] = useState(null);
    const [paramState, setParam] = useState('');
    const [rowID, setRowID] = useState('');
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate();
    const [modalMessage, setModalMessage] = useState('');
    const [messageType, setMessageType] = useState(''); // 'error', 'success', or 'warning'
    const [showNotificationModal, setShowNotificationModal] = useState(false);

    let csrfToken = sessionStorage.getItem("tokenizedSession");

    const urlParams = new URLSearchParams(window.location.search);
    const paramValue = urlParams.get('param');
    const prefix = paramValue.split('_')[0];

    // Remove everything before the first underscore
    const tablenames = paramValue.substring(paramValue.indexOf('_') + 1);

    const templateFormHeading = tablenames.replace(/_/g, ' ').split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');

    const toTitleCase = (str) => {
        return str
            // Replace underscores or hyphens with spaces
            .replace(/[_-]/g, ' ')
            // Add space before capital letters (for camelCase)
            .replace(/([a-z])([A-Z])/g, '$1 $2')
            // Capitalize first letter of each word
            .replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());
    };

    useEffect(() => {
        const fetchFormStructure = async () => {
            setLoading(true); // Start loading
            try {
                const rowIDValue = urlParams.get('rowIndex');
                setParam(paramValue);
                setRowID(rowIDValue);

                // const responsefromFile = await fetch(`${PortURL}/demformtemplate/${paramValue}.json`);
                const responsefromFile = await fetch(`/demformtemplate/${paramValue}.json`);
                if (!responsefromFile.ok) {
                    throw new Error('Nothing pending for Modification');
                }

                const responsetxt = await responsefromFile.json();

                setFormStructure(responsetxt);

                const initialFormData = {};
                if (Array.isArray(responsetxt.details)) {
                    responsetxt.details.forEach(detail => {
                        if (detail.columnActive === "N") {
                            // Handle columns with columnKey values
                            if (detail.columnKey === "" || detail.columnKey?.toLowerCase() === "null" || detail.columnKey?.toLowerCase() === "not null") {
                                // Assign dummy values based on columnType
                                switch (detail.columnType.toUpperCase()) {
                                    case 'INT':
                                    case 'INTEGER':
                                        initialFormData[detail.columnName] = 0; // Integer dummy value
                                        break;
                                    case 'VARCHAR':
                                    case 'CHAR':
                                    case 'TEXT':
                                        initialFormData[detail.columnName] = 'N'; // String dummy value
                                        break;
                                    case 'DATE':
                                        initialFormData[detail.columnName] = '1900-01-01'; // Default date
                                        break;
                                    default:
                                        initialFormData[detail.columnName] = null; // Unsupported types
                                }
                            }
                        }
                        initialFormData[detail.columnName] = '';
                    });
                } else {
                    throw new Error('Form structure is not an array.');
                }

                // ✅ Pre-calculate computed fields before setting state
                const preCalculated = calculateDynamicFields(initialFormData, responsetxt);

                // ✅ Set updated data to state
                setFormData(preCalculated);
                console.log('Initial Form Data:', preCalculated);

            } catch (error) {
                console.error('Error fetching form structure:', error);
            } finally {
                setLoading(false); // End loading
            }
        };

        fetchFormStructure();
    }, [paramValue]);

    useEffect(() => {
        if (formStructure && rowID) {
            fetchDataAndBindToForm();
        }
    }, [formStructure, rowID]);

    const fetchDataAndBindToForm = async () => {
        try {
            // const responseDataFile = await fetch(`${PortURL}/jsonfiles/${paramValue}_retrieved.json`);
            const responseDataFile = await fetch(`/jsonfiles/${paramValue}_retrieved.json`);
            if (!responseDataFile.ok) {
                throw new Error('Nothing pending for Modification');
            }
            const responseData = await responseDataFile.json();
            bindDataToForm(responseData, rowID);
        } catch (error) {
            console.error('Error fetching data:', error);
            setError('Failed to load data.');
        }
    };
    const handleInputChange = (columnName, value) => {
        if (!formStructure) return; // safety check

        setFormData((prevFormData) => {
            // Step 1: Update changed field
            const updatedFormData = { ...prevFormData, [columnName]: value };

            // Step 2: Recalculate computed/dynamic fields
            const recalculated = calculateDynamicFields(updatedFormData, formStructure);
            console.log("updatedFormData", updatedFormData);
            console.log("recalculated", recalculated);

            // Step 3: Return recalculated data
            return recalculated;
            
        });
    };

    const bindDataToForm = (data, rowID) => {
        if (!data || !formStructure) return;

        const rowData = data.find(row => String(row.rowId) === String(rowID));

        if (rowData) {
            let updatedFormStructure = [...formStructure.details];

            // Check if "Maker_Remarks" exists in rowData but not in formStructure
            if (!updatedFormStructure.some(detail => detail.columnName === "Maker_Remarks") && rowData.Maker_Remarks !== undefined) {
                updatedFormStructure.push({
                    columnName: "Maker_Remarks",
                    columnLabel: "Maker Remarks",
                    columnType: "TEXT",
                    columnActive: "Y", // Ensure it's active
                });

                // Update form structure
                setFormStructure(prevStructure => ({
                    ...prevStructure,
                    details: updatedFormStructure
                }));
            }

            // Store dataModel separately
            const dataModelValue = rowData.dataModel;

            const updatedFormData = updatedFormStructure.reduce((acc, detail) => {
                const columnName = detail.columnName;
                let value = rowData[columnName];

                if (detail.columnType.toLowerCase() === 'datetime' && value) {
                    const date = new Date(value);
                    acc[columnName] = date.toISOString().split('T')[0];
                } else {
                    acc[columnName] = value || ''; // Default to empty string if value is null/undefined
                }
                return acc;
            }, {});

            // Attach dataModel separately to formData (but don't include it in formStructure)
            updatedFormData.dataModel = dataModelValue;

            setFormData(updatedFormData);
            console.log("Updated Form Data after binding:", updatedFormData);
        }
    };

    const isDateString = (val) => {
        if (typeof val !== "string") return false;
        // Matches YYYY-MM-DD, MM/DD/YYYY, or ISO-like formats
        return /^\d{4}-\d{2}-\d{2}$/.test(val) || /^\d{1,2}\/\d{1,2}\/\d{4}$/.test(val);
    };


    const calculateDynamicFields = (newFormData, formStructure) => {
        if (!formStructure) return newFormData;

        const details = formStructure.details;
        let calculatedData = { ...newFormData };

        details.forEach(detail => {
            const formula = detail.columnFunction?.trim();
            if (!formula) return;

                const columnName = detail.columnName;

            // 🚫 Skip dropdown definitions - they are not formulas
            if (formula.startsWith('dropdown:')) {
                return; // Skip processing for dropdowns
            }

            try {
                let expression = formula;

                // 🧩 1️⃣ Handle Function-style like Addition(a,b)
                const funcMatch = expression.match(/^(\w+)\s*\(([^)]*)\)$/i);
                if (funcMatch) {
                    const funcName = funcMatch[1];
                    const operands = funcMatch[2].split(',').map(o => o.trim());

                    // Resolve operand values (from form data or constants)
                    // const resolvedArgs = operands.map(op => calculatedData[op] ?? op);
                    // Resolve operand values in a case-insensitive way
                    const resolvedArgs = operands.map(op => {
                        const operandLower = op.toLowerCase();

                        // Find matching field ignoring case
                        const matchingKey = Object.keys(calculatedData).find(
                            k => k.toLowerCase() === operandLower
                        );

                        // If matched → return value
                        if (matchingKey) return calculatedData[matchingKey];

                        // Otherwise constant value or raw text
                        return op;
                    });


                    const toNum = (x) => parseFloat(x) || 0;
                    const [a, b, c, d, e, f] = resolvedArgs.map(toNum);

                    switch (funcName.toLowerCase()) {
                        // 🧮 Math & arithmetic
                        case 'addition':
                        case 'add': {
                            const valA = resolvedArgs[0];
                            const valB = resolvedArgs[1];

                            const isDateA = isDateString(valA);
                            const isDateB = isDateString(valB);

                            if (isDateA && !isNaN(toNum(valB))) {
                                // Add days to a date
                                const d = new Date(valA);
                                d.setDate(d.getDate() + toNum(valB));
                                calculatedData[columnName] = d.toISOString();
                            } else if (!isNaN(toNum(valA)) && !isNaN(toNum(valB))) {
                                // ✅ Numeric addition
                                calculatedData[columnName] = toNum(valA) + toNum(valB);
                            } else {
                                calculatedData[columnName] = null;
                            }
                            return;
                        }

                        case 'subtraction':
                        case 'subtract': {
                            const valA = resolvedArgs[0];
                            const valB = resolvedArgs[1];

                            const isDateA = isDateString(valA);
                            const isDateB = isDateString(valB);

                            if (isDateA && isDateB) {
                                // ✅ Date difference in days
                                const diffMs = new Date(valA) - new Date(valB);
                                calculatedData[columnName] = diffMs / (1000 * 60 * 60 * 24);
                            } else if (!isNaN(toNum(valA)) && !isNaN(toNum(valB))) {
                                // ✅ Numeric subtraction
                                calculatedData[columnName] = toNum(valA) - toNum(valB);
                            } else {
                                calculatedData[columnName] = null;
                            }
                            return;
                        }


                        case 'multiplication':
                                case 'multiply':
                            calculatedData[columnName] = a * b;
                            return;
                        case 'division':
                                case 'divide':
                            calculatedData[columnName] = b !== 0 ? a / b : 0;
                            return;

                        // 🕒 Date/Time-based functions
                        case 'now':
                            const now = new Date();
                            const formatted =
                                now.getFullYear() +
                                '-' +
                                String(now.getMonth() + 1).padStart(2, '0') +
                                '-' +
                                String(now.getDate()).padStart(2, '0') +
                                ' ' +
                                String(now.getHours()).padStart(2, '0') +
                                ':' +
                                String(now.getMinutes()).padStart(2, '0') +
                                ':' +
                                String(now.getSeconds()).padStart(2, '0');
                            calculatedData[columnName] = formatted;
                            return;

                        case 'year':
                            calculatedData[columnName] = new Date(resolvedArgs[0]).getFullYear();
                            return;
                        case 'month':
                            calculatedData[columnName] = new Date(resolvedArgs[0]).getMonth() + 1;
                            return;
                        case 'quarter':
                            calculatedData[columnName] = Math.floor((new Date(resolvedArgs[0]).getMonth() + 3) / 3);
                            return;
                        case 'second':
                            calculatedData[columnName] = new Date(resolvedArgs[0]).getSeconds();
                            return;
                        case 'dayofmonth':
                            calculatedData[columnName] = new Date(resolvedArgs[0]).getDate();
                            return;
                        case 'dayofweek':
                            calculatedData[columnName] = new Date(resolvedArgs[0]).getDay();
                            return;

                        case 'weeknumber': {
                            const inputDate = new Date(resolvedArgs[0]);
                            if (isNaN(inputDate)) {
                                calculatedData[columnName] = null;
                                return;
                            }

                            const target = new Date(inputDate.valueOf());
                            const dayNr = (inputDate.getDay() + 6) % 7; // Monday = 0
                            target.setDate(target.getDate() - dayNr + 3);
                            const firstThursday = new Date(target.getFullYear(), 0, 4);
                            const weekNo = 1 + Math.round(
                                ((target - firstThursday) / 86400000 - 3 + ((firstThursday.getDay() + 6) % 7)) / 7
                            );

                            calculatedData[columnName] = weekNo;
                            return;
                        }
                        case 'dayofyear': {
                            const d = new Date(resolvedArgs[0]);
                            const start = new Date(d.getFullYear(), 0, 0);
                            const diff = d - start;
                            calculatedData[columnName] = Math.floor(diff / (1000 * 60 * 60 * 24));
                            return;
                        }

                        case 'datefrommdy': {
                            const [m, dy, y] = operands.map(o => toNum(calculatedData[o]) || toNum(o));
                            calculatedData[columnName] = `${y}-${String(m).padStart(2, '0')}-${String(dy).padStart(2, '0')}`;
                            return;
                        }

                        case 'datefromyq': {
                            const [yArg, qArg] = operands;
                            const yVal = new Date(calculatedData[yArg] || yArg).getFullYear() || toNum(yArg);
                            const qVal = toNum(calculatedData[qArg]) || 1;
                            const month = (qVal - 1) * 3 + 1;
                            calculatedData[columnName] = `${yVal}-${String(month).padStart(2, '0')}-01`;
                            return;
                        }

                        default:
                            console.warn(`⚠️ Unknown operator: ${funcName}`);
                            return;
                    }
                }

                // 🧮 2️⃣ Handle direct mathematical expressions
                const fieldNames = Object.keys(calculatedData);
                fieldNames.forEach(field => {
                    const value = parseFloat(calculatedData[field]);
                    const safeValue = isNaN(value) ? 0 : value;
                    const regex = new RegExp(`\\b${field}\\b`, 'g');
                    expression = expression.replace(regex, safeValue);
                });

                if (!/^[\d+\-*/().\s]+$/.test(expression)) {
                    console.warn(`Unsafe expression skipped for ${columnName}: ${expression}`);
                    return;
                }

                // 🧠 3️⃣ Evaluate math expression safely
                // eslint-disable-next-line no-new-func
                const result = Function(`"use strict"; return (${expression})`)();
                calculatedData[columnName] = isFinite(result) ? result : 0;

            } catch (err) {
                console.error(`Error evaluating formula for ${detail.columnName}:`, err);
            }
        });

        return calculatedData;
    };


    const handleBackClick = () => {
        navigate(-1); // This navigates back to the previous page
    };

    const handleErrorClick = () => {
    };

    const handleModalClose = () => {
        if (messageType === 'success') {
            handleBackClick(); // Only navigate if success
        } else {
            setModalMessage(''); // Close modal in case of an error
            handleErrorClick(); // Handle error without navigation
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        const newFormData = {
            ...formData,
            [name]: value
        };
        setFormData(newFormData);
        calculateDynamicFields(newFormData);
    };

    const showMessageModal = (message, type) => {
        setModalMessage(message);
        setMessageType(type);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!formStructure) {
            console.error('Form structure not loaded yet.');
            return;
        }

        // Get NOT NULL and PRIMARY KEY fields
        const mandatoryFields = formStructure.details.filter(detail => detail.columnKey === 'NOT NULL');
        const primaryKeyFields = formStructure.details.filter(detail => detail.columnKey === 'PRIMARY KEY');

        //  Forcefully treat Maker_Remarks as mandatory
        const allMandatoryFields = [...mandatoryFields];
        const makerRemarksField = formStructure.details.find(detail => detail.columnName === "Maker_Remarks");
        if (makerRemarksField && !allMandatoryFields.some(f => f.columnName === "Maker_Remarks")) {
            allMandatoryFields.push(makerRemarksField);
        }

        const missingMandatory = [];
        const missingPrimaryKey = [];

        for (const field of allMandatoryFields) {
            if (!formData[field.columnName] || formData[field.columnName].trim() === '' || ["\\N", "NULL", "/N", "//N", "0"].includes(formData[field.columnName].trim().toUpperCase())) {
                missingMandatory.push(field.columnLabel);
            }
        }

        for (const field of primaryKeyFields) {
            if (!formData[field.columnName] || formData[field.columnName].trim() === '') {
                missingPrimaryKey.push(field.columnLabel);
            }
        }

        if (missingMandatory.length > 0 || missingPrimaryKey.length > 0) {
            const missingFields = [...missingMandatory, ...missingPrimaryKey];

            const formattedFields = missingFields
                .map(field => `<span class="text-warning" style="font-size:14px; font-family:verdana">${field.toUpperCase()}</span>`)
                .join(', ');


            const message = `
        <p style="font-size:14px; color: rgba(255, 193, 7, 1); font-family:verdana; margin-bottom: 0;">
            <span style="color: rgba(255, 193, 7, 1); margin-right: 8px;">⚠️ The following fields are missing:</span>
        </p>
        <p style="font-size:14px; font-family:verdana; margin-top: 0;">
            ${formattedFields}
        </p>`;
            showMessageModal(message, 'warning');
            return;
        }

        // Proceed with valid submission
        handleNotificationSubmit();
    };

    const handleNotificationSubmit = async () => {

        try {
            const urlParam = new URLSearchParams(window.location.search);
            const paramVal = urlParam.get('param');
            const rowId = urlParam.get('rowIndex');
            const filename = tablenames + ".json"; // Example: filename can be dynamically constructed here
            const content = JSON.stringify([formData], null, 2);

            // const response = await axios.post(FormTextFile, { filename, content });
            const response = await axios.post(FormTextFile, { filename, content }, {
                headers: {
                    userId: localStorage.getItem('userid'),
                    "x-csrf-token": csrfToken
                },
                withCredentials: true,
            });

            const config = {
                headers: { "userId": localStorage.getItem('userid'), "x-csrf-token": csrfToken },
                withCredentials: true,
                params: { "rowId": rowId, "filePath": "/saswork/nas/" + filename, "Notifications": "IN", "tableName": tablenames, "dataModel": "DEM", "dept": prefix }
            };
            const responseDb = await axios.post(makermodifypastdata, {}, config);

            if (responseDb.data && responseDb.data.active_status && responseDb.data.template_type) {
                localStorage.setItem("active_status", responseDb.data.active_status);
                localStorage.setItem("template_type", responseDb.data.template_type);
                localStorage.setItem("stage", responseDb.data.stage);

            } else {
                console.log("active_status or template_type is missing or response.data is null");
            }

            if (responseDb.status === 200) {
                // Clear the form data
                const initialFormData = {};
                formStructure.details.forEach(detail => {
                    initialFormData[detail.columnName] = '';
                });
                setFormData(initialFormData);
                if (responseDb.data && responseDb.data.message) {
                    const message = responseDb.data.message;
                    if (responseDb.data.status === "success") {
                        showMessageModal(`1 record of <strong>${toTitleCase(tablenames)}</strong> Modified Successfully`, 'success'); // Show success modal in green
                        setShowModal(true);
                        setMessageType('success');
                    } else {
                        showMessageModal(message, 'error');
                        setShowModal(true);

                    }
                } else {
                    showMessageModal('Unknown error occurred', 'error'); // Fallback for unexpected cases

                }
            }
        } catch (error) {
            console.error('Error updating data:', error.message);
            showMessageModal('Error updating data', 'error'); // Show error modal in red
        }

        setShowNotificationModal(false); // Close the notification modal
    };


    const renderInput = (detail) => {
        const columnValue = formData[detail.columnName] || '';
        const isPrimaryKey = detail.columnKey === 'PRIMARY KEY';

        const commonProps = {
            className: "form-control form-control-sm",
            name: detail.columnName,
            value: columnValue,
            onChange: (e) => handleInputChange(e, detail.columnName),
            disabled: isPrimaryKey, // disable if primary key
        };

        switch (detail.columnType.toLowerCase()) {
            case 'datetime':
            case 'date':
                return (
                    <input
                        type="date"
                        className="form-control form-control-sm"
                        name={detail.columnName}
                        value={formData[detail.columnName] ? formData[detail.columnName].split('T')[0] : ''}
                        onChange={handleChange}
                        disabled={isPrimaryKey}
                    />
                );

            case 'varchar':
                if (detail.columnFunction && detail.columnFunction.startsWith('dropdown')) {
                    const options = detail.columnFunction.match(/dropdown:\[([^\]]+)\]/)[1].split(',');
                    return (
                        <select {...commonProps}>
                            <option value="">--Select--</option>
                            {options.map((option) => (
                                <option key={option} value={option}>
                                    {option}
                                </option>
                            ))}
                        </select>
                    );
                }
                return <input type="text" {...commonProps} />;

            case 'int':
                return <input type="number" {...commonProps} />;

            default:
                return <input type="text" {...commonProps} />;
        }
    };


    if (loading) {
        return (
            <div>
                <Header />
                <LoadingIcon />
                <Footer />
            </div>
        );
    }


    if (!formStructure) {

        return (
            <div>
                <Header />
                <div className="position-absolute top-12 end-0 p-2" style={{ marginTop: '1px' }}>
                </div>
                <div>
                    <h5 className="text-center">{paramState.charAt(0).toUpperCase() + paramState.slice(1)} Form</h5>
                </div>
                <h6 className='text-center' style={{ marginTop: '40px' }}>Template form not available</h6>
                <footer className="footer fixed-bottom" style={{ padding: '0.5rem' }}></footer>
            </div>
        );
    }

    const handleDashboard = () => {
        navigate('/gapsyMdashboard');
    };

    const handleQuickEntry = () => {
        navigate('/gapsyQEApproveData');
    }

    return (
        <div className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}>
            <Header />
            <Navigation />
            <div className="top-0 px-4 py-2 text-white">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-1">
                                <li className="breadcrumb-item">
                                    <a onClick={handleDashboard} href="#" className={`text-info ${styles.textInfo}`} style={{ textDecoration: 'none' }}>
                                        <i className="bi bi-house me-2"></i>/
                                    </a>
                                </li>
                                <li className={`breadcrumb-item active ${styles.breadcrumbItem}`} aria-current="page">
                                    <a onClick={handleQuickEntry} href="#" className={`text-info ${styles.textInfo}`} style={{ textDecoration: 'none' }}>
                                        <i className="bi bi-file-earmark me-2"></i>2.1 Modify Rejected Data
                                    </a>
                                </li>
                                <li className={`breadcrumb-item active ${styles.breadcrumbItem}`} aria-current="page">
                                    <i className="bi bi-x-circle me-2"></i>2.1.1a Modify Template Form
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <main className="flex-grow-1 container-fluid">
                <div className={styles.mainContainer}>
                    <div className="container-fluid py-2">
                        <div className="row">
                            <div className="col-lg-12 col-md-12">
                                <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                    <div className="card-body">
                                        <div className="mb-4">
                                            <h6 className={`pb-1 mb-3 ${styles.borderBottom}`}>
                                                Modify Template Form : {templateFormHeading} Form
                                            </h6>
                                            <div className="row p-2">
                                                <div style={{ maxHeight: '250px', overflowY: 'auto', width: '100%' }}>
                                                    <FormStructureComponent
                                                        paramState={tablenames}
                                                        formStructure={formStructure}
                                                        formData={formData}
                                                        handleSubmit={handleSubmit}
                                                        renderInput={renderInput}
                                                        handleInputChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
            <Modal show={modalMessage} style={{ marginTop: '12vh' }}>
                <div className={`alert alert-${messageType === 'success' ? 'success' : (messageType === 'warning' ? 'warning' : 'danger aa')} alert-dismissible fade show`}
                    role="alert"
                    style={{ marginBottom: '0' }}
                >
                    <div className="align-items-center">
                        {messageType === 'success' ? (
                            <span className="me-2" style={{ color: 'green', marginBottom: "14px" }}>✅</span>
                        ) : messageType === 'error' ? (
                            <span className="me-2" style={{ color: 'red', marginBottom: "14px" }}>❌</span>
                        ) : null}

                        <p style={{
                            display: 'inline',
                            fontSize: '14px',
                            color: messageType === 'success' ? 'green' :
                                (messageType === 'warning' ? 'black' : 'red'),
                        }}

                            dangerouslySetInnerHTML={{ __html: modalMessage }} >
                        </p>
                    </div>

                    <button
                        type="button"
                        className="btn-close"
                        onClick={handleModalClose} // Single function to handle both success and error cases
                        style={{
                            width: '15px',
                            height: '15px',
                            fontSize: '8px',
                            position: 'absolute',
                            bottom: '10px',
                            right: '10px',
                        }}
                    ></button>
                </div>
            </Modal >
        </div>
    );
};

export default GapsyModifyPastData;
